import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LogisticsLanding() {
  const navigate = useNavigate();

  useEffect(() => {
    const authorized = false;
    if (authorized) {
      navigate('/app/table');
    }
  }, [status, open, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-purple-200">
      {/* Header */}
      <header className="flex justify-between items-center p-6 bg-white/80 backdrop-blur-sm">
        <div className="flex items-center">
          <div className="w-32 h-8 bg-gray-300 rounded flex items-center justify-center text-gray-600 font-medium">
            LOGO
          </div>
        </div>
        <div className="flex gap-4">
          <button
            onClick={() => navigate('/login')}
            className="w-full px-8 py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Get Started
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-6 py-16">
        {/* Hero Section */}
        <div className="text-center mb-20">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">Automate Your Logistics Communication</h1>
          <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto">
            Streamline operations and speed up communication for expeditors and logistics managers — all in one platform
          </p>
          <div className="px-8 py-3 flex justify-center">
            <button
              onClick={() => navigate('/login')}
              className="px-8 py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              Get Starteds
            </button>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gray-100 p-8 rounded-xl">
            <div className="w-12 h-12 bg-gray-300 rounded-lg mb-4"></div>
            <h3 className="text-xl font-semibold mb-3">Automated Workflows</h3>
            <p className="text-gray-600">
              Reduce manual tasks and streamline your logistics processes with intelligent automation.
            </p>
          </div>

          <div className="bg-gray-100 p-8 rounded-xl">
            <div className="w-12 h-12 bg-gray-300 rounded-lg mb-4"></div>
            <h3 className="text-xl font-semibold mb-3">Real-time Updates</h3>
            <p className="text-gray-600">
              Keep all stakeholders informed with instant notifications and status updates.
            </p>
          </div>

          <div className="bg-gray-100 p-8 rounded-xl">
            <div className="w-12 h-12 bg-gray-300 rounded-lg mb-4"></div>
            <h3 className="text-xl font-semibold mb-3">Smart Analytics</h3>
            <p className="text-gray-600">
              Make data-driven decisions with comprehensive logistics insights and reporting.
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gray-900 text-white p-12 rounded-2xl text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Operations?</h2>
          <p className="text-xl text-gray-300 mb-8">
            Join logistics professionals who are already saving time and improving efficiency.
          </p>
          {/* <button className="px-8 py-3 bg-white text-gray-900 rounded-lg text-lg font-medium hover:bg-gray-100 transition-colors">
            Start Free Trial
          </button> */}
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-20 bg-gray-900 text-white py-12"></footer>
    </div>
  );
}
